import { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Checkbox,
  Text,
  Box,
  VStack,
  useToast,
} from '@chakra-ui/react';
import { useTerms } from '../../contexts/TermsContext';

export function TermsModal() {
  const { needsAcceptance, terms, acceptTerms, loading } = useTerms();
  const [accepted, setAccepted] = useState(false);
  const [accepting, setAccepting] = useState(false);
  const toast = useToast();

  const handleAccept = async () => {
    if (!accepted) {
      toast({
        title: 'Atenção',
        description: 'Você precisa aceitar os termos para continuar',
        status: 'warning',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
      return;
    }

    setAccepting(true);
    try {
      await acceptTerms();
      toast({
        title: 'Sucesso',
        description: 'Termos aceitos com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
    } catch (error) {
      toast({
        title: 'Erro',
        description: 'Erro ao aceitar termos. Tente novamente.',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
    } finally {
      setAccepting(false);
    }
  };

  if (loading || !needsAcceptance || !terms) {
    return null;
  }

  return (
    <Modal
      isOpen={needsAcceptance}
      onClose={() => {}}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      size="4xl"
      isCentered
    >
      <ModalOverlay bg="blackAlpha.700" backdropFilter="blur(10px)" />
      <ModalContent maxH="90vh">
        <ModalHeader>
          <VStack align="start" spacing={1}>
            <Text fontSize="2xl" fontWeight="bold">
              {terms.title}
            </Text>
            <Text fontSize="sm" color="gray.500">
              Versão {terms.version}
            </Text>
          </VStack>
        </ModalHeader>

        <ModalBody overflowY="auto" maxH="60vh">
          <Box
            p={4}
            borderWidth="1px"
            borderRadius="md"
            bg="gray.50"
            _dark={{ bg: 'gray.800' }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: terms.content.replace(/\n/g, '<br />'),
              }}
              style={{
                lineHeight: '1.6',
                whiteSpace: 'pre-wrap',
              }}
            />
          </Box>
        </ModalBody>

        <ModalFooter flexDirection="column" gap={4}>
          <Checkbox
            isChecked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
            colorScheme="brand"
            size="lg"
          >
            <Text fontSize="md">Li e aceito os termos de uso e política de privacidade</Text>
          </Checkbox>

          <Button
            colorScheme="brand"
            size="lg"
            width="100%"
            onClick={handleAccept}
            isDisabled={!accepted || accepting}
            isLoading={accepting}
            loadingText="Aceitando..."
          >
            Aceitar e Continuar
          </Button>

          <Text fontSize="xs" color="gray.500" textAlign="center">
            Ao aceitar, você concorda com todos os termos descritos acima.
            <br />
            Seus dados de aceitação (IP, data/hora) serão registrados para fins de auditoria.
          </Text>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
